import { useOwner } from "./owner-context";
import { useProfile } from "./profile-context";
import { ProfileType } from "./types";

export const useOwnerProfile = function () {
  const owner = useOwner();
  const profile = useProfile();

  if (!profile?.data) {
    return undefined;
  }

  if (profile.data.type === ProfileType.Student) {
    return profile.contact;
  }

  if (!owner) {
    return undefined;
  }

  if (profile?.data?.type === ProfileType.Guardian) {
    const student = profile.data.relatedStudents?.find((related) => {
      return related.profile.email === owner.email;
    });

    if (student) {
      return student;
    }

    // if owner if Guardian
    if (profile.data.email === owner.email) {
      return profile.contact;
    }
  }

  return undefined;
};
